export default __webpack_public_path__ + "static/media/39.d129c6b8.png";